var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(!_vm.isMobile)?_c('el-header',{attrs:{"height":"56px"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/logo.png")}})]):_vm._e(),_c('el-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }